"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = exports.isFieldEqual = void 0;
var compose_1 = __importDefault(require("lodash/fp/compose"));
var identity_1 = __importDefault(require("lodash/fp/identity"));
var isEqual_1 = __importDefault(require("lodash/fp/isEqual"));
var toLower_1 = __importDefault(require("lodash/fp/toLower"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
var first_1 = __importDefault(require("lodash/fp/first"));
var split_1 = __importDefault(require("lodash/fp/split"));
var getZip5 = (0, compose_1.default)(first_1.default, (0, split_1.default)('-'));
var isUSAddress = (0, compose_1.default)((0, isEqual_1.default)('US'), (0, prop_1.default)('country'));
/**
 * Check whether two [[Address]]es' specified field are equal.
 *
 * For US `postalCode`, it will not compare the zip+4 digital, that means `'12345-1234'` are equal to `'12345-4321'`
 *
 * ```
 * const isEqual = isFieldEqual(source)(target)('city');
 * ```
 * */
var isFieldEqual = function (source) { return function (target) { return function (field) {
    var fieldValue = (0, compose_1.default)(isUSAddress(source) && isUSAddress(target) && field === 'postalCode' ? getZip5 : identity_1.default, toLower_1.default, (0, prop_1.default)(field));
    return (0, isEqual_1.default)(fieldValue(source))(fieldValue(target));
}; }; };
exports.isFieldEqual = isFieldEqual;
/**
 * Check whether two [[Address]]es are equal.
 *
 * ```
 * const isEqual = isEqual(source)(target);
 * ```
 * */
var isEqual = function (source) { return function (target) {
    var isEqualWith = (0, exports.isFieldEqual)(source)(target);
    return isEqualWith('city')
        && isEqualWith('line1')
        && isEqualWith('line2')
        && isEqualWith('country')
        && isEqualWith('stateProvince')
        && isEqualWith('postalCode');
}; };
exports.isEqual = isEqual;
